mutation CreateSubmissionsCSV($input: SubmissionsCsvGenerateInput!) {
    submissionsCsvGenerate(input: $input) {
        url
    }
}
